module.exports = __webpack_public_path__ + "static/media/1382.afe78909.jpg";